function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("rect", {
  className: "th0",
  height: 298.7,
  width: 512,
  y: 106.7
}), React.createElement("rect", {
  className: "th1",
  height: 199.1,
  width: 512,
  y: 156.4
}), React.createElement("rect", {
  className: "th2",
  height: 99.6,
  width: 512,
  y: 206.2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    version: 1.1,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/thailand.1700dcda.svg";
export { SvgComponent as ReactComponent };